import React from 'react'
import classNames from 'classnames'

import { IntegrationServiceId } from '../common/integrations'
import GotoWordmark from '../assets/images/goto-wordmark.png'

import { ReactComponent as WealthboxLogo } from '../assets/images/integration-logos/color/wealthbox-logo.svg'
import { ReactComponent as HubSpotLogo } from '../assets/images/integration-logos/color/hubspot-logo.svg'
import { ReactComponent as RedtailLogo } from '../assets/images/integration-logos/color/redtail-logo.svg'
import { ReactComponent as SalesforceLogo } from '../assets/images/integration-logos/color/salesforce-logo.svg'
import { ReactComponent as PractifiLogo } from '../assets/images/integration-logos/color/practifi-logo.svg'
import { ReactComponent as XLR8Logo } from '../assets/images/integration-logos/color/XLR8-logo.svg'
import { ReactComponent as MeetLogo } from '../assets/images/integration-logos/color/google-meet-logo.svg'
import { ReactComponent as OutlookMailLogo } from '../assets/images/integration-logos/color/microsoft-outlook-mail-logo.svg'
import { ReactComponent as OutlookCalendarLogo } from '../assets/images/integration-logos/color/microsoft-outlook-calendar-logo.svg'
import { ReactComponent as ExchangeLogo } from '../assets/images/integration-logos/color/microsoft-exchange.svg'
import { ReactComponent as PhoneLogo } from '../assets/images/integration-logos/color/phone-logo.svg'
import { ReactComponent as GmailLogo } from '../assets/images/integration-logos/color/gmail-logo.svg'
import { ReactComponent as ZohoLogo } from '../assets/images/integration-logos/color/zoho-logo.svg'
import { ReactComponent as DynamicsLogo } from '../assets/images/integration-logos/color/microsoft-dynamics-logo.svg'
import { ReactComponent as SmartOfficeLogo } from '../assets/images/integration-logos/color/smartoffice-logo.svg'
import { ReactComponent as EMoneyLogo } from '../assets/images/integration-logos/color/emoney-logo.svg'
import { ReactComponent as RightCapitalLogo } from '../assets/images/integration-logos/color/right-capital-logo.svg'
import { ReactComponent as OrionLogo } from '../assets/images/integration-logos/color/orion-logo.svg'
import { ReactComponent as HolistiplanLogo } from '../assets/images/integration-logos/color/holistiplan-logo.svg'
import { ReactComponent as PreciseFPLogo } from '../assets/images/integration-logos/color/precise-fp-logo.svg'
import { ReactComponent as ElementsLogo } from '../assets/images/integration-logos/color/elements-logo.svg'
import { ReactComponent as BlackDiamondLogo } from '../assets/images/integration-logos/color/black-diamond-logo.svg'
import { ReactComponent as BlackDiamondWpLogo } from '../assets/images/integration-logos/color/black-diamond-wp-logo.svg'
import { ReactComponent as ZoomLogo } from '../assets/images/integration-logos/color/zoom-logo.svg'
import { ReactComponent as ZoomPhoneLogo } from '../assets/images/integration-logos/color/zoom-phone-logo.svg'
import { ReactComponent as WebexLogo } from '../assets/images/integration-logos/color/webex-logo.svg'
import { ReactComponent as EngageLogo } from '../assets/images/integration-logos/color/engage-logo.svg'
import { ReactComponent as AdvisorEngineLogo } from '../assets/images/integration-logos/color/advisorengine-logo.svg'
import { ReactComponent as ClicLogo } from '../assets/images/integration-logos/color/clic-logo.svg'
import { ReactComponent as InvestCloudLogo } from '../assets/images/integration-logos/color/investcloud-inc-logo.svg'
import { ReactComponent as GoogleCalendarLogo } from '../assets/images/integration-logos/color/google-calendar-logo.svg'
import { ReactComponent as TeamsCallsLogo } from '../assets/images/integration-logos/color/microsoft-teams-calls-logo.svg'
import { ReactComponent as TeamsLogo } from '../assets/images/integration-logos/color/microsoft-teams-logo.svg'
import { ReactComponent as WealthLogo } from '../assets/images/integration-logos/color/wealth-logo.svg'
import { ReactComponent as WoveLogo } from '../assets/images/integration-logos/color/wove-logo.svg'
import { ReactComponent as DelegatedEmailLogo } from '../assets/images/integration-logos/color/delegated-email-logo.svg'
import { ReactComponent as RingcentralLogo } from '../assets/images/integration-logos/color/ringcentral-logo.svg'
import { ReactComponent as GotoLogo } from '../assets/images/integration-logos/color/goto-logo.svg'
import { ReactComponent as ConquestPlanningLogo } from '../assets/images/integration-logos/color/conquest-planning-logo.svg'
import { ReactComponent as SchwabLogo } from '../assets/images/integration-logos/color/schwab-logo.svg'
import { ReactComponent as BoxLogo } from '../assets/images/integration-logos/color/box-logo.svg'
import { ReactComponent as SharePointLogo } from '../assets/images/integration-logos/color/microsoft-sharepoint-logo.svg'
import { ReactComponent as EgnyteLogo } from '../assets/images/integration-logos/color/egnyte-logo.svg'
import { ReactComponent as OneDriveLogo } from '../assets/images/integration-logos/color/onedrive-logo.svg'
import { ReactComponent as GoogleDriveLogo } from '../assets/images/integration-logos/color/google-drive-logo.svg'
import { ReactComponent as LinkedInLogo } from '../assets/images/integration-logos/color/linkedin-logo.svg'

import { ReactComponent as WealthboxLogoFilled } from '../assets/images/integration-logos/fillable/wealthbox-logo-fillable.svg'
import { ReactComponent as HubSpotLogoFilled } from '../assets/images/integration-logos/fillable/hubspot-logo-fillable.svg'
import { ReactComponent as RedtailLogoFilled } from '../assets/images/integration-logos/fillable/redtail-logo-fillable.svg'
import { ReactComponent as SalesforceLogoFilled } from '../assets/images/integration-logos/fillable/salesforce-logo-fillable.svg'
import { ReactComponent as PractifiLogoFilled } from '../assets/images/integration-logos/fillable/practifi-logo-fillable.svg'
import { ReactComponent as XLR8LogoFilled } from '../assets/images/integration-logos/fillable/XLR8-logo-fillable.svg'
import { ReactComponent as MeetLogoFilled } from '../assets/images/integration-logos/fillable/google-meet-logo-fillable.svg'
import { ReactComponent as OutlookMailLogoFilled } from '../assets/images/integration-logos/fillable/microsoft-outlook-mail-logo-fillable.svg'
import { ReactComponent as OutlookCalendarLogoFilled } from '../assets/images/integration-logos/fillable/microsoft-outlook-calendar-logo-fillable.svg'
import { ReactComponent as ExchangeLogoFilled } from '../assets/images/integration-logos/fillable/microsoft-exchange-fillable.svg'
import { ReactComponent as PhoneLogoFilled } from '../assets/images/integration-logos/fillable/phone-logo-fillable.svg'
import { ReactComponent as GmailLogoFilled } from '../assets/images/integration-logos/fillable/gmail-logo-fillable.svg'
import { ReactComponent as LinkedInLogoFilled } from '../assets/images/integration-logos/fillable/linkedin-logo-fillable.svg'
import { ReactComponent as ZohoLogoFilled } from '../assets/images/integration-logos/fillable/zoho-logo-fillable.svg'
import { ReactComponent as DynamicsLogoFilled } from '../assets/images/integration-logos/fillable/microsoft-dynamics-logo-fillable.svg'
import { ReactComponent as SmartOfficeLogoFilled } from '../assets/images/integration-logos/fillable/smartoffice-logo-fillable.svg'
import { ReactComponent as EMoneyLogoFilled } from '../assets/images/integration-logos/fillable/emoney-logo-fillable.svg'
import { ReactComponent as RightCapitalLogoFilled } from '../assets/images/integration-logos/fillable/right-capital-logo-fillable.svg'
import { ReactComponent as OrionLogoFilled } from '../assets/images/integration-logos/fillable/orion-logo-fillable.svg'
import { ReactComponent as HolistiplanLogoFilled } from '../assets/images/integration-logos/fillable/holistiplan-logo-fillable.svg'
import { ReactComponent as PreciseFPLogoFilled } from '../assets/images/integration-logos/fillable/precise-fp-logo-fillable.svg'
import { ReactComponent as ElementsLogoFilled } from '../assets/images/integration-logos/fillable/elements-logo-fillable.svg'
import { ReactComponent as BlackDiamondLogoFilled } from '../assets/images/integration-logos/fillable/black-diamond-logo-fillable.svg'
import { ReactComponent as BlackDiamondWpLogoFilled } from '../assets/images/integration-logos/fillable/black-diamond-wp-logo-fillable.svg'
import { ReactComponent as ZoomLogoFilled } from '../assets/images/integration-logos/fillable/zoom-logo-fillable.svg'
import { ReactComponent as WebexLogoFilled } from '../assets/images/integration-logos/fillable/webex-logo-fillable.svg'
import { ReactComponent as EngageLogoFilled } from '../assets/images/integration-logos/fillable/engage-logo-fillable.svg'
import { ReactComponent as AdvisorEngineLogoFilled } from '../assets/images/integration-logos/fillable/advisorengine-logo-fillable.svg'
import { ReactComponent as ClicLogoFilled } from '../assets/images/integration-logos/fillable/clic-logo-fillable.svg'
import { ReactComponent as InvestCloudLogoFilled } from '../assets/images/integration-logos/fillable/investcloud-inc-logo-fillable.svg'
import { ReactComponent as GoogleCalendarLogoFilled } from '../assets/images/integration-logos/fillable/google-calendar-logo-fillable.svg'
import { ReactComponent as TeamsLogoFilled } from '../assets/images/integration-logos/fillable/microsoft-teams-logo-fillable.svg'
import { ReactComponent as WealthLogoFilled } from '../assets/images/integration-logos/fillable/wealth-logo-fillable.svg'
import { ReactComponent as WoveLogoFilled } from '../assets/images/integration-logos/fillable/wove-logo-fillable.svg'
import { ReactComponent as DelegatedEmailLogoFilled } from '../assets/images/integration-logos/fillable/delegated-email-logo-fillable.svg'
import { ReactComponent as RingcentralLogoFilled } from '../assets/images/integration-logos/fillable/ringcentral-logo-fillable.svg'
import { ReactComponent as GotoLogoFilled } from '../assets/images/integration-logos/fillable/goto-logo-fillable.svg'
import { ReactComponent as ConquestPlanningLogoFilled } from '../assets/images/integration-logos/fillable/conquest-planning-logo-fillable.svg'
import { ReactComponent as SchwabLogoFilled } from '../assets/images/integration-logos/fillable/schwab-logo-fillable.svg'
import { ReactComponent as BoxLogoFilled } from '../assets/images/integration-logos/fillable/box-logo-fillable.svg'
import { ReactComponent as SharePointLogoFilled } from '../assets/images/integration-logos/fillable/microsoft-sharepoint-logo-fillable.svg'
import { ReactComponent as EgnyteLogoFilled } from '../assets/images/integration-logos/fillable/egnyte-logo-fillable.svg'
import { ReactComponent as OneDriveLogoFilled } from '../assets/images/integration-logos/fillable/onedrive-logo-fillable.svg'
import { ReactComponent as GoogleDriveLogoFilled } from '../assets/images/integration-logos/fillable/google-drive-logo-fillable.svg'

//Please only use 24x24 SVGs for integration icons
const _INTEGRATION_ICON_MAP: { [key in IntegrationServiceId]: React.FC<React.SVGProps<SVGSVGElement>> } = {
  [IntegrationServiceId.ZOOM]: ZoomLogo,
  [IntegrationServiceId.GOOGLE_CALENDAR]: GoogleCalendarLogo,
  [IntegrationServiceId.TEAMS]: TeamsLogo,
  [IntegrationServiceId.WEALTHBOX]: WealthboxLogo,
  [IntegrationServiceId.HUBSPOT]: HubSpotLogo,
  [IntegrationServiceId.REDTAIL]: RedtailLogo,
  [IntegrationServiceId.SALESFORCE]: SalesforceLogo,
  [IntegrationServiceId.PRACTIFI]: PractifiLogo,
  [IntegrationServiceId.XLR8]: XLR8Logo,
  [IntegrationServiceId.MEET]: MeetLogo,
  [IntegrationServiceId.OUTLOOK_CALENDAR]: OutlookCalendarLogo,
  [IntegrationServiceId.EXCHANGE_CALENDAR]: ExchangeLogo,
  [IntegrationServiceId.WEALTHBOX_CALENDAR]: WealthboxLogo,
  [IntegrationServiceId.PHONE]: PhoneLogo,
  [IntegrationServiceId.GMAIL]: GmailLogo,
  [IntegrationServiceId.OUTLOOK_MAIL]: OutlookMailLogo,
  [IntegrationServiceId.EXCHANGE_MAIL]: ExchangeLogo,
  [IntegrationServiceId.ZOHO]: ZohoLogo,
  [IntegrationServiceId.DYNAMICS]: DynamicsLogo,
  [IntegrationServiceId.CUSTOM]: () => null,
  [IntegrationServiceId.SMARTOFFICE]: SmartOfficeLogo,
  [IntegrationServiceId.E_MONEY]: EMoneyLogo,
  [IntegrationServiceId.RIGHT_CAPITAL]: RightCapitalLogo,
  [IntegrationServiceId.ORION]: OrionLogo,
  [IntegrationServiceId.HOLISTIPLAN]: HolistiplanLogo,
  [IntegrationServiceId.PRECISE_FP]: PreciseFPLogo,
  [IntegrationServiceId.ELEMENTS]: ElementsLogo,
  [IntegrationServiceId.BLACK_DIAMOND]: BlackDiamondLogo,
  [IntegrationServiceId.BLACK_DIAMOND_WP]: BlackDiamondWpLogo,
  [IntegrationServiceId.WEBEX]: WebexLogo,
  [IntegrationServiceId.ENGAGE]: EngageLogo,
  [IntegrationServiceId.ADVISOR_ENGINE]: AdvisorEngineLogo,
  [IntegrationServiceId.CLIC]: ClicLogo,
  [IntegrationServiceId.INVESTCLOUD]: InvestCloudLogo,
  [IntegrationServiceId.WEALTH]: WealthLogo,
  [IntegrationServiceId.WOVE]: WoveLogo,
  [IntegrationServiceId.DELEGATED_EMAIL]: DelegatedEmailLogo,
  [IntegrationServiceId.RINGCENTRAL]: RingcentralLogo,
  [IntegrationServiceId.GOTO]: GotoLogo,
  [IntegrationServiceId.TEAMS_CALLS]: TeamsCallsLogo,
  [IntegrationServiceId.CONQUEST_PLANNING]: ConquestPlanningLogo,
  [IntegrationServiceId.SCHWAB]: SchwabLogo,
  [IntegrationServiceId.BOX]: BoxLogo,
  [IntegrationServiceId.ONEDRIVE]: OneDriveLogo,
  [IntegrationServiceId.SHAREPOINT]: SharePointLogo,
  [IntegrationServiceId.EGNYTE]: EgnyteLogo,
  [IntegrationServiceId.GOOGLE_DRIVE]: GoogleDriveLogo,
  [IntegrationServiceId.LINKEDIN]: LinkedInLogo,
}

//Please only use 24x24 SVGs for integration icons
//Please use unfilled SVGs that can be filled via the 'fill' prop
const _BLACK_INTEGRATION_ICON_MAP: { [key in IntegrationServiceId]: React.FC<React.SVGProps<SVGSVGElement>> } = {
  [IntegrationServiceId.ZOOM]: ZoomLogoFilled,
  [IntegrationServiceId.GOOGLE_CALENDAR]: GoogleCalendarLogoFilled,
  [IntegrationServiceId.TEAMS]: TeamsLogoFilled,
  [IntegrationServiceId.WEALTHBOX]: WealthboxLogoFilled,
  [IntegrationServiceId.HUBSPOT]: HubSpotLogoFilled,
  [IntegrationServiceId.REDTAIL]: RedtailLogoFilled,
  [IntegrationServiceId.SALESFORCE]: SalesforceLogoFilled,
  [IntegrationServiceId.PRACTIFI]: PractifiLogoFilled,
  [IntegrationServiceId.XLR8]: XLR8LogoFilled,
  [IntegrationServiceId.MEET]: MeetLogoFilled,
  [IntegrationServiceId.OUTLOOK_CALENDAR]: OutlookCalendarLogoFilled,
  [IntegrationServiceId.EXCHANGE_CALENDAR]: ExchangeLogoFilled,
  [IntegrationServiceId.WEALTHBOX_CALENDAR]: WealthboxLogoFilled,
  [IntegrationServiceId.PHONE]: PhoneLogoFilled,
  [IntegrationServiceId.GMAIL]: GmailLogoFilled,
  [IntegrationServiceId.OUTLOOK_MAIL]: OutlookMailLogoFilled,
  [IntegrationServiceId.EXCHANGE_MAIL]: ExchangeLogoFilled,
  [IntegrationServiceId.ZOHO]: ZohoLogoFilled,
  [IntegrationServiceId.DYNAMICS]: DynamicsLogoFilled,
  [IntegrationServiceId.CUSTOM]: () => null,
  [IntegrationServiceId.SMARTOFFICE]: SmartOfficeLogoFilled,
  [IntegrationServiceId.E_MONEY]: EMoneyLogoFilled,
  [IntegrationServiceId.RIGHT_CAPITAL]: RightCapitalLogoFilled,
  [IntegrationServiceId.ORION]: OrionLogoFilled,
  [IntegrationServiceId.HOLISTIPLAN]: HolistiplanLogoFilled,
  [IntegrationServiceId.PRECISE_FP]: PreciseFPLogoFilled,
  [IntegrationServiceId.ELEMENTS]: ElementsLogoFilled,
  [IntegrationServiceId.BLACK_DIAMOND]: BlackDiamondLogoFilled,
  [IntegrationServiceId.BLACK_DIAMOND_WP]: BlackDiamondWpLogoFilled,
  [IntegrationServiceId.WEBEX]: WebexLogoFilled,
  [IntegrationServiceId.ENGAGE]: EngageLogoFilled,
  [IntegrationServiceId.ADVISOR_ENGINE]: AdvisorEngineLogoFilled,
  [IntegrationServiceId.CLIC]: ClicLogoFilled,
  [IntegrationServiceId.INVESTCLOUD]: InvestCloudLogoFilled,
  [IntegrationServiceId.WEALTH]: WealthLogoFilled,
  [IntegrationServiceId.WOVE]: WoveLogoFilled,
  [IntegrationServiceId.DELEGATED_EMAIL]: DelegatedEmailLogoFilled,
  [IntegrationServiceId.RINGCENTRAL]: RingcentralLogoFilled,
  [IntegrationServiceId.GOTO]: GotoLogoFilled,
  [IntegrationServiceId.TEAMS_CALLS]: TeamsCallsLogo,
  [IntegrationServiceId.CONQUEST_PLANNING]: ConquestPlanningLogoFilled,
  [IntegrationServiceId.SCHWAB]: SchwabLogoFilled,
  [IntegrationServiceId.BOX]: BoxLogoFilled,
  [IntegrationServiceId.ONEDRIVE]: OneDriveLogoFilled,
  [IntegrationServiceId.SHAREPOINT]: SharePointLogoFilled,
  [IntegrationServiceId.EGNYTE]: EgnyteLogoFilled,
  [IntegrationServiceId.GOOGLE_DRIVE]: GoogleDriveLogoFilled,
  [IntegrationServiceId.LINKEDIN]: LinkedInLogoFilled,
}

const _WORDMARK_LOGO_MAP: Partial<Record<IntegrationServiceId, { src: string; alt: string }>> = {
  [IntegrationServiceId.GOTO]: { src: GotoWordmark, alt: 'GoTo' },
}

const _PHONE_LOGO_MAP: Partial<Record<IntegrationServiceId, React.FC<React.SVGProps<SVGSVGElement>>>> = {
  [IntegrationServiceId.ZOOM]: ZoomPhoneLogo,
}

interface IntegrationIconProps {
  serviceId: IntegrationServiceId
  className?: string
  fill?: string
  width?: string | number
  height?: string | number
  preferWordmark?: boolean
  preferPhone?: boolean
}

export const IntegrationIcon: React.FC<IntegrationIconProps> = ({ serviceId, className, fill, width, height, preferWordmark, preferPhone }) => {
  const wordmark = preferWordmark ? _WORDMARK_LOGO_MAP[serviceId] : undefined
  if (wordmark) {
    return <img src={wordmark.src} alt={wordmark.alt} width={width} height={height} className={classNames(className, 'object-fit-contain')} />
  }

  const PhoneIcon = preferPhone ? _PHONE_LOGO_MAP[serviceId] : undefined
  if (PhoneIcon) {
    return <PhoneIcon className={className} width={width} height={height} />
  }

  const Icon = fill ? _BLACK_INTEGRATION_ICON_MAP[serviceId] : _INTEGRATION_ICON_MAP[serviceId]
  if (!Icon) {
    return null
  }

  return <Icon className={className} fill={fill} width={width} height={height} />
}
